import React from "react";
import Context from "../../../Context";
import Blocker from "../Blocker";
export default class CommentsList extends React.Component {
  static contextType = Context;
  render() {
    let comments = this.props.comments || [];
    let level = 0;
    return (
      <>
        <Blocker on={this.props.parentPending}>
          {comments.map((item) => {
            let comment = item || {};
            let date = comment.created ? new Date(comment.created) : {};
            if (comment.parent) {
              level++;
              if (level > 6) level = 6;
            } else {
              level = 0;
            }

            let text = item.text ? item.text.replace(/\n/g, "<br />") : "";
            return (
              <div
                key={comment.id}
                id={`comment${comment.id}`}
                className="mb-3 pb-3 border-bottom"
              >
                <div style={{ paddingLeft: level * 20 }} className="d-flex">
                  <div className="symbol symbol-40 mr-3">
                    {comment.picture ? (
                      <img alt="userpic" src={comment.picture} />
                    ) : (
                      <span className="symbol-label font-size-h5 font-weight-bold bg-primary-o-20">
                        {this.context.user.getLiteral(comment.name)}
                      </span>
                    )}
                  </div>
                  <div>
                    <div
                      className="text-dark-50 small cursor-pointer text-hover-primary"
                      onClick={() => this.props.onReply(comment)}
                    >
                      {item.name}
                      <i className="fa fa-mail-reply  ml-2"></i>
                    </div>
                    <div
                      className="my-2"
                      dangerouslySetInnerHTML={{ __html: text }}
                    ></div>
                    <div className="text-muted small">
                      {date.toLocaleString()}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Blocker>
      </>
    );
  }
}
